export default __webpack_public_path__ + "static/media/whatsapp.70168863.png";